import { render } from "./SecurityMain.vue?vue&type=template&id=3048afd8&scoped=true"
import script from "./SecurityMain.vue?vue&type=script&lang=js"
export * from "./SecurityMain.vue?vue&type=script&lang=js"

import "./SecurityMain.vue?vue&type=style&index=0&id=3048afd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3048afd8"]])

export default __exports__